import { AfterViewInit, Component, ElementRef, HostListener, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { AnchorModel } from 'src/app/shared/models/node';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { NodeService } from 'src/app/shared/services/node.services';

@Component({
  selector: 'app-page-bando',
  templateUrl: './page-bando.component.html',
  styleUrls: ['./page-bando.component.scss']
})
export class PageBandoComponent implements OnInit {

  @Input() node: any;
  @Input() anchorItems: AnchorModel[] = [];
  @Input() isSecondLevelUp: boolean = false;
  public idAnchor: string = '';
  public block: any;
  public imgPath = "";
  public isSpinner: boolean = false;
  public titlePage: string = '';
  public isCollapseHeader: boolean = false;
  public isShowLocalMenu: any;
  public dataFieldTaxonomies: any[] = [];
  //MODALE SHARE
  public onHoverShare: boolean = false;

  @ViewChild('descBando') set content(content: ElementRef) {
    this.helpersService.setStyleTables(this.renderer);
  }

  constructor(
    public helpersService: HelpersService,
    private nodeService: NodeService,
    private renderer: Renderer2
  ) { }

  ngOnInit(): void {
    this.nodeService.getRowTypeView(this.node.langcode[0].value, this.node.field_oggetto_view[0].value, this.node.field_tipo_view[0].value, this.node.preview, this.node.nid[0].value).subscribe(resView => {
      this.block = resView[0];
      this.checkScadenza();
      this.setDataFields(this.block);
      this.titlePage = this.helpersService.retriveLinkTagA(this.block.field_titolo, 'a').title;
    });
    this.isSpinner = true;
    this.helpersService.showLocalMenuBS.subscribe(value => {
      this.isShowLocalMenu = value;
    });
  }

  @HostListener('document:scroll', ['$event'])
  public onViewportScroll() {
    let boundingCollapse;
    if (this.isSpinner && this.node) {
      boundingCollapse = document.querySelector('.container-field-taxonomies')?.getBoundingClientRect();
    }
    if ((boundingCollapse && boundingCollapse.y < -40 && boundingCollapse.width > 767) || (boundingCollapse && boundingCollapse.y < -200 && boundingCollapse.width <= 767)) {
      this.isCollapseHeader = true;
    } else {
      this.isCollapseHeader = false;
    }
  }

  addNewAnchorItem(value: AnchorModel) {
    if (value.labelRow !== '') {
      this.anchorItems.push(value);
    }
    this.anchorItems.sort((a, b) => a.position - b.position);
    // this.idAnchor = this.anchorItems[0].idRow;
  }

  public openMenu(): void {
    this.helpersService.openLocalMenuBS.next(true);
  }

  private setDataFields(block: any): void {
    if (block.field_tassonomia_dipartimento.length) {
      this.dataFieldTaxonomies = [
        ...this.dataFieldTaxonomies,
        {
          titolo: 'CONTENT_TYPES.PAGE_BANDO.DEPARTMENT',
          value: block.field_tassonomia_dipartimento,
          isArray: true
        }
      ]
    }
    if (block.field_tassonomia_corsi_di_laurea.length) {
      this.dataFieldTaxonomies = [
        ...this.dataFieldTaxonomies,
        {
          titolo: 'CONTENT_TYPES.PAGE_BANDO.DEGREE_COURSE',
          value: block.field_tassonomia_corsi_di_laurea,
          isArray: true
        }
      ]
    }
    if (block.field_tassonomia_categoria_bando.length) {
      this.dataFieldTaxonomies = [
        ...this.dataFieldTaxonomies,
        {
          titolo: 'CONTENT_TYPES.PAGE_BANDO.TYPOLOGY_ANNOUNCEMENT',
          value: block.field_tassonomia_categoria_bando,
          isArray: true
        }
      ]
    }
    if (this.node.field_status.length && this.node.field_status[0].value) {
      this.dataFieldTaxonomies = [
        ...this.dataFieldTaxonomies,
        {
          titolo: 'CONTENT_TYPES.PAGE_BANDO.STATUS',
          value: this.node.field_status[0].value === 'Aperto' ? this.helpersService.getIstant("BLOCK.SAMPLE_SINGLE_ANNOUNCEMENT.OPEN"): this.helpersService.getIstant("BLOCK.SAMPLE_SINGLE_ANNOUNCEMENT.CLOSED"),
          isArray: false,
          translate: false
        }
      ]
    }
    if (this.node.field_scadenza.length && this.node.field_scadenza[0].value) {
      this.dataFieldTaxonomies = [
        ...this.dataFieldTaxonomies,
        {
          titolo: 'CONTENT_TYPES.PAGE_BANDO.EXPIRATION',
          value: this.node.field_scadenza[0].value,
          isArray: false,
          date: 'dd MMMM yyyy'
        }
      ]
    }
  }

  private checkScadenza(): void {
    const now = new Date();
      const scadenzaString = this.block.field_scadenza_export ? this.block.field_scadenza_export : this.block.field_scadenza;
      const datetimeRegex = /datetime="([^"]+)"/;
      const match = datetimeRegex.exec(scadenzaString);
      if (match) {
        const scadenzaDate = new Date(match[1]);
        if (now.getTime() > scadenzaDate.getTime()) {
          this.block.statusFE = false;
        } else {
          this.block.statusFE = true;
        }
        const oraFE = scadenzaDate.getHours() + ':' + scadenzaDate.getMinutes().toString().padStart(2, '0');;
        this.block.oraFE = oraFE;
      } else {
      }
  }

}
